import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import {
  MDBBox, MDBContainer, MDBProgress, MDBTypography,
} from 'mdbreact';
import { UserContext } from '../Components/UserContext';
import FloatTabs from '../Components/FloatTabs';
import CategoryWiseTable from '../Components/CategoryWiseTable';
import './UserPage.css';

const UserPage = ({ baseURL }) => {
  const userContext = useContext(UserContext);
  const [eventData, setEventData] = useState(null);
  const [eventDataError, setEventDataError] = useState(false);
  const [isAlum, setIsAlum] = useState(false);
  const [userExists, setUserExists] = useState(true);

  const [categoryData, setCategoryData] = useState(null);
  const [categoryDataError, setCategoryDataError] = useState(false);

  const rollNum = userContext.email.split('@')[0].toUpperCase();

  let totalHours = 0;
  const maxHours = 180;
  const reqHours = 120;

  useEffect(() => {
    // TODO: Change this to a localstorage check or something
    if (userContext.name !== '') {
      fetch(`${baseURL}/api/user/${rollNum}`)
        .then((res) => {
          if (res.statusText.toLowerCase() === 'not found') {
            setUserExists(false);
          } else {
            // console.log('API Response:', res);
            return res.json();
          }
        })
        .then((res) => {
          // console.log('Parsed JSON Data:', res);
          setEventData(res.activities);
          setIsAlum(res.info ? !res.info.is_active : false);
        })
        .catch((err) => {
          console.log('Mymymy', err);
          setEventDataError(true);
          setCategoryDataError(true);
          console.log(err);
        });
    }
  }, [baseURL, rollNum, userContext.name]);

  useEffect(() => {
    if (eventData) {
      setUserExists(true);
      setEventDataError(false);
      fetch(`${baseURL}/api/categories`)
        .then((res) => res.json())
        .then((res) => {
          const categoryList = [];
          res.categories.forEach((category) => {
            let hours = 0;
            eventData.forEach((event) => {
              if (event.category === category.category_id) {
                hours += event.hours;
              }
            });

            categoryList.push({
              id: category.category_id,
              hoursCompleted: hours,
              hoursNeeded: category.hours_needed,
            });
          });

          setCategoryData(categoryList);
        })
        .catch((err) => {
          console.log(err);
          setCategoryDataError(true);
        });
    }
  }, [eventData, baseURL]);

  // TODO: Change this check to a check for localstorage token, or something like that
  if (userContext.name === '') {
    return <Redirect to="/" />;
  }

  if (eventData) {
    eventData.forEach((event) => {
      totalHours += event.hours;
    });
  }

  return (
    <MDBContainer fluid>
      <p className="h4 text-center pt-4 pb-2"> User Profile </p>
      <MDBBox display="flex" justifyContent="around" id="user-profile">
        <div className="user-info">
          <p className="text-center">
            Name:&nbsp;
            {userContext.name}
          </p>
        </div>
        <div className="user-info">
          <p className="text-center">
            Roll Number:&nbsp;
            {rollNum}
          </p>
        </div>
      </MDBBox>
      <div className="" style={{ width: '67%', margin: 'auto' }}>
        <MDBProgress
          material
          min={0}
          max={isAlum ? 90 : maxHours}
          value={totalHours}
          color={totalHours >= reqHours ? 'success' : 'info'}
          height="22px"
        >
          <strong>
            {totalHours}
            &nbsp;Hours
          </strong>
        </MDBProgress>
        <br />
        <MDBContainer>
          <CategoryWiseTable eventData={eventData} />
        </MDBContainer>
      </div>

      {!userExists ? (
        <MDBContainer>
          <MDBTypography note noteColor="danger" noteTitle="Error: ">
            You are not registered in the database. Please contact
            {' '}
            <a href="mailto:office.nss@iith.ac.in">office.nss@iith.ac.in</a>
          </MDBTypography>
        </MDBContainer>
      ) : (
        <FloatTabs
          eventData={eventData}
          eventDataError={eventDataError}
          categoryData={categoryData}
          categoryDataError={categoryDataError}
        />
      )}
    </MDBContainer>
  );
};

export default UserPage;
